if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			// Ekranı full gösteren eski kod

			// if ( ! document.getElementById('zoom') ) {
			// 	this.zoom = document.createElement('div');
			// 	this.zoom.id = 'zoom';
			// 	this.zoom.innerHTML = `
			// 		<img />
			// 		<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
			// 		<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
			// 		<div class="zoom__overlay"></div>
			// 	`;
			// 	document.body.append(this.zoom);
			// 	this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
			// }

			if (!document.getElementById('zoom')) {
    this.zoom = document.createElement('div');
    this.zoom.id = 'zoom';

    // Set styles for mobile and desktop
    if (window.innerWidth <= 768) { // Mobile
        this.zoom.style.width = '100%'; // Full width on mobile
        this.zoom.style.height = 'auto'; // Automatic height
        this.zoom.style.position = 'fixed';
        this.zoom.style.top = '0'; // Align to the top
        this.zoom.style.left = '0'; // Align to the left
        this.zoom.style.right = '0'; // Ensure full width
        this.zoom.style.bottom = '0'; // Ensure full height
    } else { // Desktop
        this.zoom.style.width = '50%'; // Width for desktop
        this.zoom.style.height = '80%'; // Height for desktop
        this.zoom.style.margin = 'auto';
        this.zoom.style.position = 'fixed';
        this.zoom.style.top = '5%'; // Top margin for desktop
        this.zoom.style.left = '5%'; // Left margin for desktop
        this.zoom.style.right = '5%'; // Right margin for desktop
        this.zoom.style.bottom = '5%'; // Bottom margin for desktop
    }

    this.zoom.innerHTML = `
        <img />
        <span class="zoom__exit" style="position:fixed; top:7%; right:7%; cursor:pointer; z-index:1000;">${KROWN.settings.symbols.zoom_out}</span>
        <span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
        <div class="zoom__overlay" style="position:fixed; top:0; left:0; right:0; bottom:0; background-color:rgba(0,0,0,0.6);"></div>
    `;
    document.body.append(this.zoom);
    this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
    this.zoom.querySelector('.zoom__overlay').addEventListener('click', this._productZoomUnmount.bind(this));
}
 else {
				this.zoom = document.getElementById('zoom');
			}

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

			this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			});

		}

		onMouseMoveHandler(e){
//			window.clientX = e.clientX;
//			window.clientY = e.clientY;
	//		const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
		//	const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
		//	this.image.style.left = x + 'px';
		//	this.image.style.top = y + 'px';
		}

		onResizeHandler(){

			const rf = window.innerWidth > 768 ? 0.5 : 1;

			if ( this.image.classList.contains('portrait') ) {
				this.image.style.width = ( window.innerWidth*rf ) + 'px';
				this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
			} else {

				this.image.style.height = ( window.innerHeight*rf ) + 'px';
				this.image.style.width = ( window.innerHeight*rf * this.image.dataset.ratio ) + 'px';

				if ( this.image.offsetWidth < window.innerWidth ) {
					this.image.style.width = ( window.innerWidth*rf ) + 'px';
					this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
				}

			}

			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;

		}

		_productZoomMount(image) {

			this.image.style.left = 0;
			this.image.style.top = 0;

			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
			}, 300);

		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}
